import React, { Component } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LoginResponse } from "../dto/auth.dto";
import { getAuth } from '../assets/redux/AuthRedux';
interface Props extends RouteProps {
  component: React.ComponentType<any>;
}
const PrivateRoute = ({ component: Component, ...rest }: Props) => {
  const userData = useSelector((state: any) => getAuth(state.AuthRedux)) as LoginResponse;

  return <Route {...rest} render={(props) => (
    userData != null && userData.token != undefined
      ? <Component {...props} />
      : <Redirect to='/auth/signin' />
  )
  } />
}
export default PrivateRoute;